import { Classroom } from '@/types/classroom';
import { gql } from '@apollo/client';

export interface GetClassResponse {
    testroom: Classroom;
}

export const GET_CLASSROOM = gql`
    query Testroom($where: TestroomWhereUniqueInput!) {
        testroom(where: $where) {
            id
            testroomName
            startTime
            endTime
            serverTime
            otp
            lessonVersion {
                id
                lessonName
            }
            class {
                id
            }
            passlock
            offlineMode
            writingHints
            freeStyleMode
        }
    }
`;

export interface GetLessonVersionResponse {
    lessonVersion: {
        id: string;
        lessonName: string;
        slides: {
            id: string;
            sort: number;
            data: unknown;
            questionCount?: number;
        }[];
        published: boolean;
        parent: {
            id: string;
            shareWithPublic: boolean;
            teacher: {
                id: string;
                user: {
                    id: string;
                };
            };
        };
    };
}

export interface GetLessonVersionVariables {
    where: {
        id: string;
    };
}

export const GET_LESSON_VERSION = gql`
    query LessonVersion($where: LessonVersionWhereUniqueInput!) {
        lessonVersion(where: $where) {
            id
            lessonName
            slides {
                id
                sort
                data
                questionCount
            }
            published
            parent {
                id
                shareWithPublic
                teacher {
                    id
                    user {
                        id
                    }
                }
            }
        }
    }
`;
